angular.module('iw.frontyard.signup')
    .controller('CustomerSignupController', function ($scope,
                                                      SignupPage,
                                                      IwocaSiteHelper) {

        $scope.signup = SignupPage;
        $scope.IwocaSiteHelper = IwocaSiteHelper;

        $scope.choices = [
            {name: 'Inventory/Stock purchase', value: 'stock_purchase'},
            {name: 'Bridging loan', value: 'bridging_loan'},
            {name: 'Marketing', value: 'marketing'},
            {name: 'Equipment/buildings purchase', value: 'equipment_purchase'},
            {name: 'Pay a due bill', value: 'pay_bill'},
            {name: 'Pay staff', value: 'pay_staff'},
            {name: 'Refinancing debt', value: 'refinancing_debt'},
            {name: 'Other', value: 'other'}
        ];

        $scope.selectedChoice = '';
    });
